// utils/images.js
// Centralized image management
export const images = {
  hero: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1600&h=900&fit=crop',
  about: 'https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=600&h=400&fit=crop',
  programs: {
    education: 'https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=400&h=300&fit=crop',
    healthcare: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop',
    women: 'https://images.unsplash.com/photo-1593113646773-028c64a8f1b8?w=400&h=300&fit=crop',
    environment: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=400&h=300&fit=crop',
    youth: 'https://images.unsplash.com/photo-1529390079861-591de354faf5?w=400&h=300&fit=crop',
    rural: 'https://images.unsplash.com/photo-1518398046578-8cca57782e17?w=400&h=300&fit=crop'
  },
  impact: {
    story: 'https://images.unsplash.com/photo-1531206715517-5c0ba140b2b8?w=600&h=400&fit=crop',
    testimonial1: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100&h=100&fit=crop',
    testimonial2: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    testimonial3: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  },
  gallery: [
    'https://images.unsplash.com/photo-1547483238-f400e65ccd56?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1542810634-71277d95dcbb?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=400&h=300&fit=crop'
  ],
  logo: 'https://via.placeholder.com/200x60/3498db/ffffff?text=Pragathi+NGO',
  partners: [
    'https://via.placeholder.com/150x80/f8f9fa/333?text=Partner+1',
    'https://via.placeholder.com/150x80/f8f9fa/333?text=Partner+2',
    'https://via.placeholder.com/150x80/f8f9fa/333?text=Partner+3',
    'https://via.placeholder.com/150x80/f8f9fa/333?text=Partner+4'
  ]
};